import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import environmentVariables from "../../../config/environmentVariables";
const DescriptionIcon = `${environmentVariables?.cdnUrl}Description.svg`
const DetailIcon      = `${environmentVariables?.cdnUrl}destail.svg`
const PropertiesIcon  = `${environmentVariables?.cdnUrl}properties.svg`

const Span = styled.span`
  padding: 0 10px 0 0;
`;
const Root = styled.div`
  z-index: 1;
`;
const ImageIcon = styled.img``;

const TabsNftDetails = ({ data, fetchDetails ,specificData }) => {


  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Root>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ width: "100%", marginTop:"20px" , border: "1px solid #151a1c" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Span>
            {" "}
            <ImageIcon src={DescriptionIcon} />
          </Span>
          <Typography sx={{  flexShrink: 0, fontWeight: "600" }}>
            Description
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "flex", justifyContent: "center" }}>
          <Typography style={{ width: "90%", textAlign: "justify", color: "#9d9d9d", wordBreak:"break-all"}}>
         {specificData?.description || "Description Not available"}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        style={{ width: "100%", border: "1px solid #151a1c" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Span>
            {" "}
            <ImageIcon src={PropertiesIcon} />
          </Span>
          <Typography sx={{flexShrink: 0, fontWeight: "600" }}>
            Properties
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "flex" , alignItems: "center"}}>
          <Typography
          style={{fontSize:"18px", color:"#9D9D9D"}}
          >Hash Rate:</Typography>
          <Typography
          style={{padding:"0 15px" , fontSize:"18px", color:"#9D9D9D"}}
          >{specificData?.hash || "-"}</Typography>
        </AccordionDetails>
        <AccordionDetails style={{ display: "flex" , alignItems: "center"}}>
          <Typography style={{fontSize:"18px", color:"#9D9D9D"}}>Daily Rewards: </Typography>
          <Typography style={{padding:"0 15px" , fontSize:"18px", color:"#9D9D9D"}}>{specificData?.dailyReward}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        style={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Span>
            {" "}
            <ImageIcon src={DetailIcon} />
          </Span>
          <Typography sx={{  flexShrink: 0, fontWeight: "600" }}>
            Details
          </Typography>
        </AccordionSummary>
        {/* <AccordionDetails>
          <Typography>Highest Bidder</Typography>
          <Typography>{data?.highestBidder}</Typography>
        </AccordionDetails> */}
        <AccordionDetails style={{ display: "flex", alignItems: "center"  }}>
          <Typography style={{fontSize:"18px", color:"#9D9D9D"}}>Owner Address </Typography>
          <Typography style={{padding:"0 15px" , fontSize:"18px", color:"#9D9D9D"}}>{specificData?.owner.slice(0, 6)}.....{specificData?.owner.slice(-4)}</Typography>
        </AccordionDetails>
        <AccordionDetails style={{ display: "flex", alignItems: "center"  }}>
          <Typography style={{fontSize:"18px", color:"#9D9D9D"}}>Highest Bidder: </Typography>
          <Typography style={{padding:"0 15px" , fontSize:"18px", color:"#9D9D9D"}}> {parseInt(data?.highestBidder?.slice(0,6))}....{parseInt(data?.highestBidder?.slice(-2))} </Typography>
        </AccordionDetails>
        <AccordionDetails style={{ display: "flex", alignItems: "center"  }}>
          <Typography style={{fontSize:"18px", color:"#9D9D9D"}}> Highest Bid : </Typography>
          <Typography style={{padding:"0 15px" , fontSize:"18px", color:"#9D9D9D"}}> {parseInt(data?.highestBid)} </Typography>
        </AccordionDetails>
      </Accordion>
    </Root>
  );
};

export default TabsNftDetails;
